import React from 'react';

/**
 * Leyenda de juego responsable — P3.
 *
 * ⚠️ ESTE ARCHIVO ES EL ÚNICO LUGAR DONDE SE CAMBIA EL TEXTO.
 *
 * La fórmula está en una constante y no incrustada en el JSX a propósito:
 * queda **pendiente de confirmación del área legal de INPROJUY** si Jujuy
 * adhirió al régimen nacional (Resolución 446/2025, modificada por la
 * 271/2026, BO 6/8/2026) o si rige una norma provincial con otra redacción.
 * El día que se confirme, se cambia UNA línea de acá y cambia en los dos
 * lugares donde aparece — la franja del carrusel del hero y el pie.
 *
 * Va en MAYÚSCULAS en el código y NO por `text-transform`: es un texto
 * normado y lo que se audita es lo que está escrito, no el resultado de una
 * transformación de CSS que mañana alguien puede sacar sin darse cuenta.
 *
 * ── Por qué NO tiene estética de disclaimer legal ────────────────────────
 * El hallazgo (nivel A, convergente en cuatro estudios) es que jugadores y
 * no jugadores atienden MENOS a los mensajes de juego responsable que a
 * cualquier otra información, y que ponerlos "en gris chico al pie" cumple
 * la letra de la norma y garantiza cero efecto.
 *
 * Entonces, tres decisiones deliberadas, todas en `HomeComercial.css`:
 *   1. El cuerpo va al mismo tamaño que el contenido secundario de la pieza
 *      que la contiene (.86rem, la misma escala que `.hc-jp-meta` y que los
 *      enlaces del pie), nunca más chico. No es letra chica.
 *   2. Va en el color de tinta plena de la página (crema al 100%), que la
 *      deja MÁS contrastada que el texto que la rodea. Es lo más legible de
 *      su zona, no lo menos.
 *   3. Usa el vocabulario visual de la pieza —el filete punteado del
 *      troquel y una ficha redonda como las bolillas—, así que se lee como
 *      parte del billete y no como un pie de página pegado abajo.
 */

/** El texto normado. Cambiarlo acá y en ningún otro lado. */
export const LEYENDA_JUEGO_RESPONSABLE =
  'EL JUGAR COMPULSIVAMENTE ES PERJUDICIAL PARA LA SALUD';

/** La marca de edad que la norma pide junto a la leyenda. */
export const EDAD_MINIMA = '+18';

/** Se conserva la línea de ayuda que ya tenía el pie: suma, no la pide la norma. */
export const LINEA_AYUDA = '0800-333-0333';

/**
 * @param {'franja'|'pie'} variante
 *   `franja` — la banda del 10% inferior reservada en el carrusel del hero.
 *   `pie`    — la misma leyenda a ancho de contenido en el pie de la home.
 */
export default function LeyendaJuegoResponsable({ variante = 'franja' }) {
  return (
    <div className={`hc-jr hc-jr-${variante}`}>
      {/* `aria-hidden` porque "+18" leído en voz alta no dice nada: la
          restricción de edad la dice la frase completa de abajo, que es la
          que escucha un lector de pantalla. */}
      <span className="hc-jr-edad" aria-hidden="true">{EDAD_MINIMA}</span>
      <p className="hc-jr-texto">
        <b>{LEYENDA_JUEGO_RESPONSABLE}</b>
        <span className="hc-jr-ayuda">
          {/* Lo que la ficha "+18" dice de forma visual, escrito para quien
              la escucha en vez de verla. No es texto decorativo repetido:
              la ficha va `aria-hidden` justamente para que esto no se diga
              dos veces. */}
          <span className="hc-sr-only">Prohibida la participación a menores de 18 años. </span>
          Línea de ayuda <b>{LINEA_AYUDA}</b>
        </span>
      </p>
    </div>
  );
}
